(function() {
  function initGalleryGrid() {
    if (document.querySelector('.gallery-grid-toggle')) return;
    if (document.querySelector('.product-gallery-grid-overlay')) return;

    var seen = new Set();
    var images = Array.from(document.querySelectorAll('.product-media__image')).filter(function(img) {
      var src = img.currentSrc || img.src;
      if (seen.has(src)) return false;
      seen.add(src);
      return true;
    });

    if (images.length === 0) return;

    // トグルボタン
    var toggleBtn = document.createElement('button');
    toggleBtn.className = 'gallery-grid-toggle';
    toggleBtn.setAttribute('aria-label', '画像一覧を表示');
    toggleBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><rect x="1" y="1" width="6" height="6"/><rect x="9" y="1" width="6" height="6"/><rect x="17" y="1" width="6" height="6"/><rect x="1" y="9" width="6" height="6"/><rect x="9" y="9" width="6" height="6"/><rect x="17" y="9" width="6" height="6"/><rect x="1" y="17" width="6" height="6"/><rect x="9" y="17" width="6" height="6"/><rect x="17" y="17" width="6" height="6"/></svg>';
   

    var mediaContainer = document.querySelector('.product__media-wrapper, .product-media-container, .product__media');
if (mediaContainer) {
  mediaContainer.style.position = 'relative';
  mediaContainer.appendChild(toggleBtn);
} else {
  document.body.appendChild(toggleBtn);
}


    // オーバーレイ
    var overlay = document.createElement('div');
    overlay.className = 'product-gallery-grid-overlay';

    // 閉じるボタン
    var closeBtn = document.createElement('div');
    closeBtn.className = 'product-gallery-grid-overlay__close';
    closeBtn.innerHTML = '<button type="button" aria-label="閉じる">✕</button>';

    // グリッド
    var grid = document.createElement('div');
    grid.className = 'product-gallery-grid-overlay__grid';
    images.forEach(function(img) {
      var el = document.createElement('img');
      el.src = img.currentSrc || img.src;
      el.alt = img.alt || '';
      grid.appendChild(el);
    });

    overlay.appendChild(closeBtn);
    overlay.appendChild(grid);
    document.body.appendChild(overlay);

    // 開く
    toggleBtn.addEventListener('click', function() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    // 閉じる（×ボタン）
    closeBtn.querySelector('button').addEventListener('click', function() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });

    // 閉じる（背景タップ）
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryGrid);
  } else {
    initGalleryGrid();
  }
})();
